module.exports = __webpack_public_path__ + "static/sismica1-d465c710de7265cae70e81b475e5c593.jpg";